export default "__VITE_ASSET__uOCEPrYQ__"